import styled from 'styled-components';

export const StyledSpinWrap = styled.div`
  display: flex;
  justify-content: center;
  padding: 40px 0;
`;

export const StyledLogList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  /* 이력이 길어질 수 있어 모달 안에서만 스크롤되게 한다 */
  max-height: 420px;
  overflow-y: auto;
  padding: 4px 2px;
`;

export const StyledEntry = styled.div`
  padding: 10px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background-color: #fafafa;
`;

export const StyledEntryHead = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;

  .log-admin {
    font-size: 12px;
    font-weight: 600;
    color: #111827;
  }

  .log-date {
    margin-left: auto;
    font-size: 11px;
    color: #9ca3af;
  }
`;

export const StyledChangeRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 6px;
  font-size: 12px;
  line-height: 1.6;

  .change-field {
    flex: 0 0 78px;
    font-weight: 600;
    color: #6b7280;
  }

  /* 이전 값은 취소선으로 눌러 새 값이 먼저 읽히게 한다 */
  .change-before {
    color: #9ca3af;
    text-decoration: line-through;
    word-break: break-all;
  }

  .change-arrow {
    flex: 0 0 auto;
    color: #d1d5db;
  }

  .change-after {
    color: #111827;
    font-weight: 500;
    word-break: break-all;
  }

  .change-value {
    color: #374151;
    word-break: break-all;
  }
`;
